import React, { FC, useRef } from 'react';

let gradientIdCounter = 0;

function useUniqueGradientId(): string {
  const idRef = useRef<string>();

  if (!idRef.current) {
    gradientIdCounter += 1;
    idRef.current = `sparkles_${gradientIdCounter}`;
  }

  return idRef.current;
}

interface GradientSparklesIconProps {
  className?: string;
}

export const GradientSparklesIcon: FC<GradientSparklesIconProps> = ({
  className,
}) => {
  const gradientId = useUniqueGradientId();

  return (
    <svg
      aria-hidden
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33333 1V3.66667M1 2.33333H3.66667M3 10.3333V13M1.66667 11.6667H4.33333M7.66667 1L9.19048 5.57143L13 7L9.19048 8.42857L7.66667 13L6.14286 8.42857L2.33333 7L6.14286 5.57143L7.66667 1Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="7.00001"
          y1="13.0001"
          x2="7.00001"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5F58E8" />
          <stop offset="1" stopColor="#28C2F3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
